import { BaseSauce, PizzaType } from './enums';
import { IFilter, IPizza } from 'misc/interfaces';

import ingredients from 'data/ingredients.json';

export const filterPizzas = (
  allPizzas: Array<IPizza>,
  filter?: IFilter,
): Array<IPizza> => {
  let filterdPizzas: Array<IPizza> = allPizzas;

  // This is a base (sauce) filter
  if (!!filter?.base) {
    filterdPizzas = filterdPizzas.filter((pizza) => pizza.base === filter.base);
  }

  // This is an ingredient filter
  if (!!filter?.ingredients) {
    filterdPizzas = filterdPizzas.filter((pizza) => {
      const ingredientsInFilter = pizza.ingredients.filter(
        (i) => filter?.ingredients?.includes(i),
      );
      return ingredientsInFilter.length > 0;
    });
  }

  if (!!filter?.pizzaType) {
    const pizzasCarnivor = allPizzas.filter((pizza) => {
      const viandes = ingredients[0].ingredients;
      const viandesDansLesIngredients = pizza.ingredients.filter((i) =>
        viandes.includes(i),
      );
      return viandesDansLesIngredients.length > 0;
    });

    switch (filter?.pizzaType) {
      case PizzaType.carnivor:
        filterdPizzas = filterdPizzas.filter((p) => pizzasCarnivor.includes(p));
        break;
      case PizzaType.vegetarian:
        filterdPizzas = filterdPizzas.filter(
          (p) => !pizzasCarnivor.includes(p),
        );
        break;
    }
  }

  return filterdPizzas;
};

export const filterSentence = (filter?: IFilter): string => {
  let sentence = 'Voici nos pizzas ';

  if (!!filter?.base)
    switch (filter?.base) {
      case BaseSauce.tomato:
        sentence += 'avec une base tomate 🍅 ';
        break;
      case BaseSauce.creme:
        sentence += 'avec une base crème 🥛 ';
        break;
    }

  if (!!filter?.pizzaType)
    switch (filter?.pizzaType) {
      case PizzaType.carnivor:
        sentence += 'contenant de la viande 🥩 ';
        break;
      case PizzaType.vegetarian:
        sentence += 'de type vegetarienne 🥦 ';
        break;
    }

  if (!!filter?.ingredients)
    sentence += `contenant les ingrédients suivants: ${filter?.ingredients.join(
      ', ',
    )}`;

  return sentence;
};
